import { createSelector } from 'reselect';
import groupBy from 'lodash.groupby';
import { KEY } from './';
import { GlobalState } from 'store/types';
import { ClientIntegrationsState } from './types';

const getClientIntegrationsState = (state: GlobalState): ClientIntegrationsState => state[KEY];

const selectEvents = createSelector(getClientIntegrationsState, (ciState) => ciState.events);

const selectGroupedEvents = createSelector(selectEvents, (events) => groupBy(events, 'name'));

const selectGroupedVenues = createSelector(selectEvents, (events) =>
  Object.keys(groupBy(events, 'venue')).filter((v) => v !== 'undefined')
);

const selectGroupedGenres = createSelector(selectEvents, (events) =>
  Object.keys(groupBy(events, 'genre')).filter((g) => g !== 'undefined')
);

const selectClientIntegrations = createSelector(getClientIntegrationsState, (ciState) => ciState.clientIntegrations);

const selectCustomer = createSelector(getClientIntegrationsState, (ciState) => ciState.customer);

const selectAPIAccess = createSelector(getClientIntegrationsState, (ciState) => ciState.apiAccess);

const selectPending = createSelector(getClientIntegrationsState, (ciState) => ciState.action.pending);

const selectError = createSelector(getClientIntegrationsState, (ciState) => ciState.action.error);

const selectAction = createSelector(getClientIntegrationsState, (ciState) => ciState.action);

export const selectors = {
  selectEvents,
  selectGroupedEvents,
  selectGroupedVenues,
  selectGroupedGenres,
  selectClientIntegrations,
  selectCustomer,
  selectAPIAccess,
  selectPending,
  selectError,
  selectAction
};
